import React from 'react';
import { Box } from '@mui/material';
import {
  EntityAccordionNode,
  EntityDeleteDialog,
  EntityTreeEmptyState,
  EntityTreeToolbar,
} from './components';
import { useEntityTree } from './hooks';
import { EntityTreeProps } from './interfaces';

const EntityTree: React.FC<EntityTreeProps> = ({
  entities,
  onEditClick,
  onDeleteClick,
  onAddClick,
}) => {
  const {
    expandedEntities,
    searchQuery,
    setSearchQuery,
    isAllExpanded,
    totalEntitiesCount,
    rootEntitiesCount,
    filteredEntities,
    entityToDelete,
    isDeleteDialogOpen,
    handleToggle,
    handleToggleExpandAll,
    handleOpenDeleteDialog,
    handleCloseDeleteDialog,
    handleConfirmDelete,
  } = useEntityTree(entities, onDeleteClick);

  return (
    <Box sx={{ width: '100%', mt: 2 }}>
      {entities && entities.length > 0 && (
        <EntityTreeToolbar
          searchQuery={searchQuery}
          onSearchChange={setSearchQuery}
          totalEntitiesCount={totalEntitiesCount}
          rootEntitiesCount={rootEntitiesCount}
          isAllExpanded={isAllExpanded}
          onToggleExpandAll={handleToggleExpandAll}
        />
      )}

      {filteredEntities.length === 0 ? (
        <EntityTreeEmptyState
          searchQuery={searchQuery}
          onClearSearch={() => setSearchQuery('')}
        />
      ) : (
        <Box sx={{ display: 'flex', flexDirection: 'column' }}>
          {filteredEntities.map((entity) => (
            <EntityAccordionNode
              key={entity.id}
              entity={entity}
              level={0}
              expandedEntities={expandedEntities}
              onToggle={handleToggle}
              onEditClick={onEditClick}
              onDeleteClick={handleOpenDeleteDialog}
              onAddClick={onAddClick}
              searchQuery={searchQuery}
            />
          ))}
        </Box>
      )}

      <EntityDeleteDialog
        open={isDeleteDialogOpen}
        entity={entityToDelete}
        onConfirm={handleConfirmDelete}
        onCancel={handleCloseDeleteDialog}
      />
    </Box>
  );
};

export default EntityTree;
export * from './interfaces';
export * from './constants';
export * from './hooks';
export * from './components';
